<ifcs-modal-pdf [iid]="helpId"
                title="{{title | translate}}"
                [doc]="doc"
                [fileName]="fileName"
                sizeClass="help-modal-div"
                [dlDisabled]="false"
                style="width: 820px;height: 700px;"
                cancelBtnText ="{{'closeJ' | translate}}"
                okBtnText="{{'save' | translate}}"
                >
</ifcs-modal-pdf>
